const learning = {
    namespaced: true,
    state: {
        // 选中的课程
        selectLearningInfo: {},
        // 课程章节（总）
        courseChapterList:[],
        // 是否自动播放
        iscontinuous:false,
        // 所有课程列表
        // 课程方案
        courseScheme:'',
        // 课程轮次
        courseRound:1,
        // 阶段字典
        phaseList:{},
        // 控制视频观看完下一步进入作业
        studySteps:1,
        // 控制答题返回（是否作业返回）
        isHomeworkBack:false,
        // 控制闯关返回
        isChallengeBack:false,
        // 详情页跳转的章节阶段
        selectedChapterInfo:{},
        // 用于控制不用右侧章节列表进行章节/阶段的切换(做累加用于监听，变化则走切换流程)  下一章节
        studyChapter:1,
        // 用于控制不用右侧章节列表进行章节/阶段的切换(做累加用于监听，变化则走切换流程)  上一章节
        studyPreviousChapter:1,
        // 用于控制每一步完成后切换五步/章节阶段
        studyStepInfo:{
            index:1,
            step:'',  // 当前五步
        },
        // 用于控制上一步切换（五步）
        studyPreviousStep:{
            index:1,
            step:'', // 当前五步
        },
        // 是否是免费试学
        isFreeLearning:false,
        // 设置当前考试的课程id
        currentExamCourseId:'',
        // 是否进入考试列表页（仅一次，进入后状态重置）
        isEnterExamList:false,
    },
    getters: {

    },
    mutations: {
        /** 选中的课程 */
        setSelectLearningInfo(state, value) {
            state.selectLearningInfo = value;
        },
        // 课程章节（总）
        setCourseChapterList(state,value){
            state.courseChapterList = value;
        },
        // 是否播放
        changeIsContinuous(state,value){
            state.iscontinuous = value;
        },
        // 课程方案
        setCourseScheme(state,value){
            state.courseScheme = value;
        },
        // 阶段字典
        setPhaseList(state,value){
            state.phaseList = value;
        },
        // 课程轮次
        setCourseRound(state,value){
            state.courseRound = value;
        },
        // 控制视频观看完下一步进入作业(做累加)
        setStudySteps(state){
            state.studySteps++;
        },
        // 控制答题返回（是否作业返回）
        setIsHomeworkBack(state,value){
            state.isHomeworkBack = value;
        },
        // 控制闯关返回
        setIsChallengeBack(state,value){
            state.isChallengeBack = value;
        },
        // 详情页跳转的章节阶段信息
        setSelectedChapterInfo(state,value){
            state.selectedChapterInfo = value;
        },
        // 用于控制不用右侧章节列表进行章节/阶段的切换(做累加用于监听，变化则走切换流程)  下一章节阶段
        setStudyChapter(state){
            state.studyChapter++;
        },
        // 用于控制不用右侧章节列表进行章节/阶段的切换(做累加用于监听，变化则走切换流程)  上一章节阶段
        setStudyPreviousChapter(state){
            state.studyPreviousChapter++;
        },
        // 用于控制每一步完成后切换五步/章节阶段
        setStudyStepInfo(state,value){
            state.studyStepInfo.index++;
            state.studyStepInfo.step = value;
        },
        // 用于控制每一步完成后切换五步/章节阶段
        setStudyPreviousStep(state,value){
            state.studyPreviousStep.index++;
            state.studyPreviousStep.step = value;
        },
        // 用于控制是否是免费试学
        setIsFreeLearning(state,value){
            state.isFreeLearning = value;
        },
        // 设置当前考试的课程id
        setCurrentExamCourseId(state,value){
            state.currentExamCourseId = value;
        },
        // 是否进入考试列表页（仅一次，进入后状态重置）
        setIsEnterExamList(state,value){
            state.isEnterExamList = value;
        },
    },
    actions: {
    }
}

export default learning
